<script>
  import { _, theme, language } from "../stores/index";
  import {
    Flex,
    FlexItem,
    Button,
    Form,
    Submit,
    TextField,
    Modal,
    Select,
    SelectItem,
    Buttons,
    RadioGroup,
    RadioGroupItem,
  } from "@gl/design-system";
  import darkModeImg from "../assets/DarkModeImage.png";
  import lightModeImg from "../assets/LightModeImage.png";
  import { locale } from "svelte-i18n";
  import { onMount } from "svelte";

  export let active;

  let form = {};

  function handleLanguage() {
    locale.set(form.language);
    language.set(form.language);
    document.documentElement.lang = form.language;
  }

  function handleSave() {
    handleLanguage($language);
    theme.set(form.theme);
    active = false;
  }

  onMount(() => {
    if ($language) form.language = $language;
    if ($theme) form.theme = $theme;
  });
</script>

<Modal bind:active boxed>
  <div class="preferences">
    <div class="gl-title mb-5">
      {$_("common.preferences")}
    </div>

    <p>{$_("common.theme")}</p>

    <RadioGroup bind:value={form.theme}>
      <RadioGroupItem value="light" label={$_("common.light")} />
      <img src={lightModeImg} alt="light-mode-img" class="mr-4" />

      <RadioGroupItem value="dark" label={$_("common.dark")} />
      <img src={darkModeImg} alt="dark-mode-img" />
    </RadioGroup>

    <Select
      label={$_("common.language")}
      bind:value={form.language}
      style="width:100%"
    >
      <SelectItem label="English" value="en" />
      <SelectItem label="Deutsch" value="de" />
    </Select>
  </div>

  <Buttons class="mt-4">
    <Button
      on:click={() => {
        handleSave();
      }}>{$_("common.save")}</Button
    >
    <Button
      outlined
      on:click={() => {
        active = false;
      }}>{$_("common.cancel")}</Button
    >
  </Buttons>
</Modal>

<style>
  .preferences :global(.gl-select) {
    width: 100%;
  }
</style>
